module.exports = __webpack_public_path__ + "static/media/side_1.b2fb6279.png";